export const SEND_EMAIL_ACTION =
  '@webapp/onlinePayment/checkout/success/SEND_EMAIL';
export const SEND_EMAIL_SUCCESS =
  '@webapp/onlinePayment/checkout/payment/SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_FAILURE =
  '@webapp/onlinePayment/checkout/payment/SEND_EMAIL_FAILURE';
export const SEND_EMAIL_RESET =
  '@webapp/onlinePayment/checkout/payment/SEND_EMAIL_RESET';
